import type { AffiliateConfig } from '~/utils/perfilOficialConfigs';
import { useOfficialProfilesStore } from '~/stores/apostatudo/official-profiles';
import { mapOfficialProfileListItemToAffiliateConfig } from '~/utils/apostatudo/official-profile-mapper';

export type OfficialProfileListEntry = {
  /** Slug do perfil — é a chave da URL `/perfil-oficial/{slug}`. */
  affiliateName: string;
  config: AffiliateConfig;
};

/**
 * Lista de perfis oficiais pro índice e pro carrossel da home, vinda da API do
 * core. Sem perfil publicado (ou com a API fora), a lista fica vazia e o índice
 * mostra "Nenhum perfil encontrado" — não existe mais fallback hardcoded.
 */
export const useOfficialProfilesList = () => {
  const store = useOfficialProfilesStore();

  onMounted(() => {
    store.fetchList();
  });

  const items = computed<OfficialProfileListEntry[]>(() =>
    store.list.map((profile) => ({
      affiliateName: profile.slug,
      config: mapOfficialProfileListItemToAffiliateConfig(profile),
    })),
  );

  const isLoading = computed(() => !store.listLoaded);

  return { items, isLoading };
};
